module.exports = __webpack_public_path__ + "img/logement-est.625402d7.png";